import { render, staticRenderFns } from "./k-popup.vue?vue&type=template&id=060ee6d4&scoped=true"
import script from "./k-popup.vue?vue&type=script&lang=js"
export * from "./k-popup.vue?vue&type=script&lang=js"
import style0 from "./k-popup.vue?vue&type=style&index=0&id=060ee6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060ee6d4",
  null
  
)

export default component.exports